import EventEmitter from 'events';

/** ----------------------------------------
    Filter Events
 ---------------------------------------- */

export class Events extends EventEmitter {

    /** ----------------------------------------
        Filter Ready
     ---------------------------------------- */

    /**
     * The ready event is fired once the data is
     * fetched from the endpoint. The event can
     * be used to detect if the data is accessible
     * within the store class.
     */

    readyEvent() {
        this.load(false);
        this.emit('ready');
        this.update();
    }

    /** ----------------------------------------
        Filter Loading
     ---------------------------------------- */

    loadingEvent() {
        this.emit('loading', () => {

        });
    }

    /** ----------------------------------------
        Filter Loading
     ---------------------------------------- */

    resultEvent() {
        this.load(false);
        this.emit('results', {
            data: this.store.get('results').take()
        });
    }

    /** ----------------------------------------
        Filter Select
     ---------------------------------------- */

    /**
     * The filter event is listening for newly
     * selected filters. The event can be used
     * to update and fetching of results. Info
     * about the event, trigger and callbacks
     * is send during the event.
     */

    selectEvent(filters) {
        [...filters].map(filter => {
            filter.addEventListener('click', (event) => {
                this.emit('filter', {
                    value: filter.id,
                    parent: filter.parentNode.parentNode.id,
                    element: filter,
                    event: event
                });

                this.update();
            });
        });
    }


    /** ----------------------------------------
        Filter Reset
     ---------------------------------------- */

    /**
     * The reset event will reset the data and
     * handle an event that can be accessed with
     * data about the element and event.
     */

    resetEvent(reset) {
        reset.addEventListener('click', (event) => {
            this.store.reset();

            this.emit('reset', {
                element: reset,
                event: event
            });
        });
    }

}